import React from 'react'
import Nav from './Nav'
import Profile from './Profile'

const Hero = () => {
  return (
    <div className='hero'>
        <Nav/>
        <Profile/>
    </div>
  )
}

export default Hero